import React from 'react';

import './card.css';

export const Card = ({ children }) => <div className='cardBox'>{children}</div>;

// export default Card;